import { createContext } from 'react';
import * as React from 'react';

type DisableClickContext = {
  disabled: boolean;
};

export const DisableClickContext = createContext<DisableClickContext>({
  disabled: false,
});

type DisableClickContextProps = {
  disabled: boolean;
};

const DisableClickContextProvider: React.FC<DisableClickContextProps> = ({ disabled, children }) => {
  return <DisableClickContext.Provider value={{ disabled }}>{children}</DisableClickContext.Provider>;
};

export default DisableClickContextProvider;
